import { IGenericBaryFormGroup } from './GenericBaryFormGroup';

import { FormGroupHelper } from './FormGroupHelper';
import { BillAddressControls } from './builder/BillAddressFormBuilder';
import { FormGroup } from '@angular/forms';
import { BaryAddressService } from '../../services/bary-address.service';
import { Transport } from '../transport.model';
import { IAddress } from '../address.model';
import { TransportMapper } from '../../app/shared/mapper/transport-mapper';
import { patchObject } from '../../app/shared/util/object-util';

export class BillAddressFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<BillAddressControls> {
  protected declare form: FormGroup;
  name = 'billAddressForm';
  updated = false;
  controls: BillAddressControls;
  addressType: { pickup?: boolean; delivery?: boolean; address?: boolean } = { address: true };

  constructor(
    formName: string,
    addressType: {
      pickup?: boolean;
      delivery?: boolean;
      address?: boolean;
    },
    controls: BillAddressControls,
    public baryAddressUtil: BaryAddressService
  ) {
    super();
    this.addressType = addressType;
    this.name = formName;
    this.form = this.newFormGroup(controls);
    this.controls = controls;
  }

  value(): any {
    return this.form.value;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: any, overrideFullname = false): void {
    if (model instanceof Transport) {
      this.updateFormFromTransport(model);
    } else {
      this.updateFormFromBillAddress(model, overrideFullname);
    }
  }

  private updateFormFromBillAddress(address: IAddress, overrideFullname = false): void {
    const newVal = { ...address, autofill: this.baryAddressUtil.updateGmapsAddressString(address) ?? '' };
    if (!overrideFullname) {
      newVal.fullname = this.form.value.fullname ? this.form.value.fullname : address.fullname;
    }
    this.form.patchValue(newVal);
    this.updated = true;
  }

  private updateFormFromTransport(transport: Transport): void {
    let address: IAddress;
    if (this.addressType.pickup) {
      address = TransportMapper.getPickupAddress(transport);
    } else if (this.addressType.delivery) {
      address = TransportMapper.getDeliveryAddress(transport);
    }
    this.updateFormFromBillAddress(address!, undefined);
  }

  updateModel(model: IAddress | Transport): void {
    if (model instanceof Transport) {
      this.updateModelFromTransport(model);
    } else {
      this.updateModelFromAddress(model);
    }
  }

  private updateModelFromAddress(address: IAddress): void {
    patchObject(address, this.form.value);
  }

  private updateModelFromTransport(transport: Transport): void {
    patchObject(transport, this.form.value);
  }
}
